<img src="assets/img/loader.svg" />
